import { render, staticRenderFns } from "./EditIndustry.vue?vue&type=template&id=40c3b4b1"
import script from "./EditIndustry.vue?vue&type=script&lang=js"
export * from "./EditIndustry.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./EditIndustry.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40c3b4b1')) {
      api.createRecord('40c3b4b1', component.options)
    } else {
      api.reload('40c3b4b1', component.options)
    }
    module.hot.accept("./EditIndustry.vue?vue&type=template&id=40c3b4b1", function () {
      api.rerender('40c3b4b1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/clients/views/EditIndustry.vue"
export default component.exports